import * as R from "ramda";

export default R.lensProp("county");
